import * as Sentry from "@sentry/react";

type ErrorContext = {
    component?: string;
    action?: string;
    extra?: Record<string, unknown>;
    tags?: Record<string, string>;
    level?: Sentry.SeverityLevel;
};

export function reportError(error: unknown, context: ErrorContext) {
    const { component, action, extra, tags, level = "error" } = context;

    // Ensure the error is an actual Error object
    const errorObject = error instanceof Error ? error : new Error(String(error));

    Sentry.captureException(errorObject, {
        tags: {
            component,
            action,
            ...tags,
        },
        extra: {
            ...extra,
        },
        level,
    });

    // You could also add other error reporting methods here
    // Like logging to a service or console in development
    if (process.env.NODE_ENV === 'development') {
        console.error(`[${component}] ${action}:`, errorObject);
    }
}

// Utility function specifically for form errors
export function reportFormError<T>(
    error: unknown,
    formData: T,
    context: {
        component: string;
        action: string;
        recordId?: string | number;
        additionalContext?: Record<string, unknown>;
    }
) {
    const { component, action, recordId, additionalContext } = context;

    reportError(error, {
        component,
        action,
        extra: {
            formData,
            recordId,
            ...additionalContext,
        },
        level: "error",
    });
}
